// to add a constant, use Constants.push('name', 'value');
// second term can be a JSON
// same name can be pushed multiple and will lead to
// an array when calling Constants.get('name');